import React, {useEffect} from 'react';
import {LocalParamList} from '../../../shared/components/tabBar/components/types';
import View from './view';
import {NavigationHelpers} from '@react-navigation/native';
import {useSelector} from 'react-redux';
import {holderProfileSelector, profileSettingsSelector} from '../../../redux/selectors/profile';
import {useLogoutDialog} from '../../../shared/hooks/useLogoutDialog';
import {useAccountLinker} from '../../../shared/hooks/useAccountLinkerHook/useAccountLinker';

export const ProfileMobile: React.FC<{navigation: NavigationHelpers<LocalParamList>}> = ({navigation}) => {
  const holderProfile = useSelector(holderProfileSelector());
  const profileSettings = useSelector(profileSettingsSelector());
  const logoutDialog = useLogoutDialog();

  const {loadLinkedAccountsInfo} = useAccountLinker();
  useEffect(() => {
    loadLinkedAccountsInfo();
  }, []);

  return View({
    onPressMenuItem(screen) {
      navigation.navigate(screen as any);
    },
    onExitClick: logoutDialog,
    holderProfile,
    profileSettings,
  });
};
